'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreSwitcher = function StoreSwitcher(el) {
  (0, _classCallCheck3.default)(this, StoreSwitcher);

  // Settings
  var countryListUK = 'uk,gb';
  var countryListUS = 'us,ca,il,vn,id,th,ph,ar,br,mx,tr,sa,ae';
  var countryListEU = 'pl,de,fr,at,be,bg,cz,dk,ee,ie,el,it,hr,cy,lv,lt,lu,hu,mt,nl,at,pt,ro,si,sk,fi,se';
  var countryListAU = 'au,nz';
  var currentStoreNameUK = 'United Kingdom';
  var currentStoreNameUS = 'United States';
  var currentStoreNameEU = 'European';
  var currentStoreNameAU = 'Australian';
  var currentStoreNameROW = 'Rest of World';
  var storeNameUK = 'United Kingdom';
  var storeNameUS = 'United States';
  var storeNameEU = 'European';
  var storeNameAU = 'Australian';
  var storeNameROW = 'Rest of the World';
  var storeUrlUK = 'https://www.caratlondon.com';
  var storeUrlUS = 'https://us.caratlondon.com';
  var storeUrlEU = 'https://eu.caratlondon.com';
  var storeUrlAU = 'https://au.caratlondon.com';
  var storeUrlROW = 'https://row.caratlondon.com';
  var flagUK = (0, _jquery2.default)('.mod-Modal_Btn-go').data('flag-gb');
  var flagEU = (0, _jquery2.default)('.mod-Modal_Btn-go').data('flag-eu');
  var flagUS = (0, _jquery2.default)('.mod-Modal_Btn-go').data('flag-us');
  var flagAU = (0, _jquery2.default)('.mod-Modal_Btn-go').data('flag-aus');
  var flagROW = (0, _jquery2.default)('.mod-Modal_Btn-go').data('flag-row');
  var redirectUrl = '';

  // Gets current store country based on the URL
  function getThisCountry() {
    var storeCountry = window.location.hostname.split('.')[0];
    if (storeCountry === 'www') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameUK);
      return 'uk';
    } else if (storeCountry === 'uk') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameUK);
      return 'uk';
    } else if (storeCountry === 'us') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameUS);
      return 'us';
    } else if (storeCountry === 'eu') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameEU);
      return 'eu';
    } else if (storeCountry === 'au') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameAU);
      return 'au';
    } else {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameROW);
      return 'row';
    }
  }

  // User wants to stay, drop a cookie so they don't see popup again
  document.querySelector('.mod-Modal_Btn-stay').onclick = function () {
    var storeCountry = getThisCountry();
    _jsCookie2.default.set('stay-' + storeCountry, 'true', { expires: 3650 });
    (0, _jquery2.default)('.mod-Modal-storeSwitcher').removeClass('mod-Modal-open');
  };

  // User wants to go so send them to the alternative store
  document.querySelector('.mod-Modal_Btn-go').onclick = function () {
    redirectUrl = redirectUrl + window.location.pathname + window.location.search;
    window.location = redirectUrl;
  };

  (0, _jquery2.default)(function () {
    var storeCountry = getThisCountry();

    // Only run if no cookie
    if (_jsCookie2.default.get('stay-' + storeCountry) === undefined && !Shopify.designMode) {
      // Look up country by IP Address
      _jquery2.default.getJSON('https://ipapi.co/json', function (data) {
        var userCountry = data.country.toLowerCase();
        storeCountry = getThisCountry();

        // console.log(data)
        // console.log(storeCountry)
        // console.log(`My country is: ${userCountry}`)
        // console.log(`The store country is: ${storeCountry}`)

        // UK / DEV
        if (storeCountry === 'uk' && countryListUK.indexOf(userCountry) < 0) {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlUK;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUK);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUK);
          }

          (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
        }

        // EU
        if (storeCountry === 'eu' && countryListEU.indexOf(userCountry) < 0) {
          if (countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUK;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUK);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUK);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUK);
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          }

          (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
        }

        // US
        if (storeCountry === 'us' && countryListUS.indexOf(userCountry) < 0) {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          } else if (countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUK;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUK);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUK);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUK);
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          }

          (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
        }

        // AU
        if (storeCountry === 'au' && countryListAU.indexOf(userCountry) < 0) {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          } else if (countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUK;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUK);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUK);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUK);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          }

          (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
        }

        // RoW / HK
        if (storeCountry === 'row') {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
            (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
            (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
          } else if (countryListUK.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUK;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUK);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUK);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUK);
            (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
            (0, _jquery2.default)('.mod-Modal-storeSwitcher').addClass('mod-Modal-open');
          }
        }
      });
    }
  });
};

exports.default = StoreSwitcher;